<template>
    <FormButton
        v-show="event.date_id"
        type="button"
        @click="event.suggestion ? openSuggestion() : confirmSuggestion()" title="Buchen"
        :class="{'bg-lime-600': event.suggestion, 'hover:bg-lime-700': event.suggestion, 'active:bg-lime-900': event.suggestion }"
    >
        <CurrencyEuroIcon class="w-5 h-5 text-white" />
    </FormButton>
    <ConfirmModal :show="confirmingSuggestion" @close="confirmingSuggestion = false">
        <template #icon>
            <CurrencyEuroIcon class="h-6 w-6 text-red-600" />
        </template>
        <template #content>
            <strong>Noch ein Klick entfernt – Damit mehr Nutzer Ihre Veranstaltung finden!</strong><br>
            Ihre Veranstaltung steht im Kulturkalender an diesem Tag in der entsprechenden Rubik und
            in der Rubrik HEUTE (alle Veranstaltungen) <strong>ab sofort oben</strong>
            und wird <strong>viel besser wahrgenommen</strong>. Für nur 95€ zzgl. MwSt.
            Sie erhalten die Rechnung per Mail.
        </template>
        <template #footer>
            <FormButton @click="confirmingSuggestion = false">Abbrechen</FormButton>
            <FormButton class="ml-3" @click="doSuggestion">Kostenpflichtig buchen</FormButton>
        </template>
    </ConfirmModal>
</template>

<script setup>
import {ref} from "vue";
import {useForm} from "@inertiajs/vue3";
import FormButton from '@/Shared/Form/Button';
import ConfirmModal from '@/Shared/Confirm';
import {CurrencyEuroIcon} from '@heroicons/vue/outline';

const props = defineProps({
    event: Object,
})
const form = useForm({})
const confirmingSuggestion = ref(false)
const confirmSuggestion = () => {
    confirmingSuggestion.value = true
}
const openSuggestion = () => {
    if (props.event.suggestion) {
        window.open(props.event.suggestion, '_blank', 'popup,noopener');
    }
}
const doSuggestion = () => {
    form.post(route('manager.date.suggest', [props.event.date_id]), {
        onSuccess: () => {
            confirmingSuggestion.value = false; openSuggestion();
        }
    })
}
</script>
